export default "__VITE_ASSET__6e7c3509__"